import { useEffect } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import { isRecordingAtom, tickAtom } from '../atoms';

export const useRecordingTimer = () => {
  const isRecording = useAtomValue(isRecordingAtom);
  const incrementTick = useSetAtom(tickAtom);

  useEffect(() => {
    if (!isRecording) return;

    const interval = setInterval(() => {
      incrementTick((t) => t + 1); // trigger re-evaluation
    }, 1000);

    return () => clearInterval(interval);
  }, [isRecording, incrementTick]);
};
